import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import { connect } from "react-redux";
import SaveConfiguration from "../Components/SaveConfiguration";
import { setVisible } from "../reducers/Ui/Actions";

const mapStateToProps = ({ ui, Configuration }) => ({
  Component: SaveConfiguration,
  ProgressComponent: CircularProgress,
  show: !!ui.visibilityMap.saveConfiguration,
  workInProgress: !!ui.backgroundWorkMap.saveConfiguration,
  errorMessage: ui.error && ui.error.message,
  code: Configuration.configuration ? Configuration.configuration.code : "",
});

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(setVisible("saveConfiguration", false)),
  onOkClick: () => dispatch(setVisible("saveConfiguration", false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SaveConfiguration);
